export default __webpack_public_path__ + "static/media/icon_toxic.34d234af.svg";